import { render, staticRenderFns } from "./xcoins.vue?vue&type=template&id=11690e3f&scoped=true&"
import script from "./xcoins.vue?vue&type=script&lang=js&"
export * from "./xcoins.vue?vue&type=script&lang=js&"
import style0 from "./xcoins.vue?vue&type=style&index=0&id=11690e3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11690e3f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcoinsPointsHero: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/PointsHero.vue').default,XcoinsExchangeDetailDialog: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/ExchangeDetailDialog.vue').default})
